export default {
    "Continue": "Continue",
    "With an Unlimited Pass your kids can attend unlimited number of small group classes with": "With an Unlimited Pass, your kids can attend unlimited number of small group classes with",
    "top certified instructors for any subjects offered by Classover":"top certified instructors for any subjects offered by Classover.",
    "Alice and Joes mother": "Alice and Joe’s mother",
    "By continuing you agree to our Terms of Use and Privacy Policy": "By continuing, you agree to our Terms of Use and Privacy Policy.",
    "Month": "Month",
    "sessions": "session",
    "One Pass that Meets Your Kids Unlimited Learning Needs": "One Pass that Meets Your Kids' Unlimited Learning Needs",
    "Pay-as-You-Go": "Pay-as-You-Go",
    "3 days ago": "3 days ago",
    "I love Classover lessons": "I love Classover lessons",
    "Number of Students": "Number of Students",
    "Get Started": "Get Started",
    "Phone Number": "Phone Number",
    "Go Back": "Go Back",
    "Personal Infomation": "Personal Infomation",
    "Payment Method": "Payment Method",
    "Pay Now": "Continue",
    "Checkout": "Checkout",
    "You will receive a confirmation email shortly": "You will receive a confirmation email shortly.",
    "Below are the contact information for your course advisor Mandy": "Below are the contact information for your course advisor Mandy.",
    "Complete Your Profile": "Complete Your Profile",
    "Parent Full Name": "Parent Full Name",
    "Email Address": "Email Address",
    "Wechat ID": "Wechat ID",
    "WeChat ID":"WeChat ID",
    "Check your phone for a code": "Check your phone for a code",
    "We are sent a 6-character code to": "We’ve sent a 6-character code to ",
    "The code expires shortly so please enter it soon":"The code expires shortly so please enter it soon.",
    "Success": "Success",
    "Billing history": "Billing history",
    "Name": "Full Name",
    "Email": "Email",
    "Name on card": "Name on card",
    "Card number": "Card number",
    "Login/Register": "Login/Register",
    "Get FREE Trial": "Get FREE Trial",
    "Please enter your mobile phone number": "Please enter your mobile phone number",
    "Incorrect mobile number format": "Incorrect mobile number format",
    "Due Date": "Due Date",
    "Total": "Total",
    "Description": "Description",
    "Please enter your full name": "Please enter your full name",
    "Please enter your email": "Please enter your email",
    "Please enter your wecaht no": "Please enter your wecaht no",
    "Logout": "Logout",
    "User Center": "User Center",
    "That code was not valid. Give it another go": "That code wasn’t valid. Give it another go!",
    "FAQ":"FAQ",
    "Please select your country code":"Please select your country code",
    "Credit Card":"Credit Card",
    "Alipay":"Alipay",
    "By continuing, I accept terms in the":"By continuing, I accept terms in the",
    "Service Payment Agreement":"Service Payment Agreement",
    "including Refund Policy. I have read the COPPA Direct Notice to Parent. I agree to subscribe to Classover newsletter, SMS messages, and accept the Terms of Use and Privacy Policy.":"including Refund Policy. I have read the COPPA Direct Notice to Parent. I agree to subscribe to Classover newsletter, SMS messages, and accept the Terms of Use and Privacy Policy.",
    "Total":"Total",
    "Pass":"Pass",
    "Payment method":"Payment method",
    "Update":"Update",
    "Real Reviews from Real Parents":"Real Reviews from Real Parents",
    "Back":"Back",
    "Congratulation!":"Congratulation!",
    "You have a Special Offer!":"You have a Special Offer!",
    "You have":"You have",
    "Hours":"Hours",
    "Minutes":"Minutes",
    "Seconds":"Seconds",
    "Kid(s) Nickname":"Kid(s) Nickname",
    "Email Address* (Required)":"E-mail",
    "Phone Number":"Phone Number",
    "Please enter the correct email address":"Please enter the correct email address",
    "Thank You":"Thank You",
    "Your order has been received":"Your order has been received",
    "Order Details":"Order Details",
    "Order number":"Order number",
    "Date":"Date",
    "Payment method":"Payment method",
    "Customer Details":"Customer Details",
    "Contact Information":"Contact Information",
    "E-mail":"E-mail",
    "Phone":"Phone",
    "advisor":"Have any questions? Please contact your course advisor",
    "Expires":"Expires",
    "Subjects":"Subjects",
    "Teachers":"Teachers",
    "Schedule":"Schedule",
    "Pricing":"Pricing",
    "Download":"Download",
    "English Reading":"English Reading",
    "Chess":"Chess",
    "Singing":"Singing",
    "Public Speaking":"Public Speaking",
    "Piano":"Piano",
    "Guitar":"Guitar",
    "Math Olympiad":"Math Olympiad",
    "Math and Logic":"Math and Logic",
    "Coding":"Coding",
    "Mandarin":"Mandarin",
    "Lego":"Lego",
    "French":"French",
    "Ukelele":"Ukelele",
    "Classic Literature":"Classic Literature",
    "Drawing":"Drawing",
    "Spanish":"Spanish",
    "Creative Writing":"Creative Writing",
    "Dance":"Dance",
    "Phonics":"Phonics",
    "MIT APP Development":"MIT APP Development",
    "VIP Package":"VIP Package",
    "Credit Package":"Credit Package",
    "Learning Needs":"One Pass that Meets Your Kids' Learning Needs",
    "Unlimited 1-6 small group classes ":"Unlimited 1-6 small group classes ",
    "Top certified U.S. teachers":"Top certified U.S. teachers",
    "100% Live classes":"100% Live classes",
    "Attend any of Afterschool or Tutoring subjects":"Attend any of Afterschool or Tutoring subjects",
    "Customized class schedule":"Customized class schedule",
    "Discounted 1:1 classes":"Discounted 1:1 classes ",
    "Enrich kids":"Enrich kids' education and keep them ahead of the curve",
   "Package / Credit Package is not selected":"Package / Credit Package is not selected",
   "Please contact our course advisor to upgrade your plan":"Please contact our course advisor to upgrade your plan",
    "Ok":"Ok, Got it",
    "Please enter the verification code":"Please enter the verification code",
   "The verification code format is incorrect":"The verification code format is incorrect",
   "Congratulations!":"Congratulations!",
   "You Received a Special Offer Today":"You Received a Special Offer Today",
   "Time is limited, please order as soon as possible":"Time is limited, please order as soon as possible",
   "Verification code":"Verification code",
   "Send":"Send",
   "This Offer Ends At":"This Offer Ends At",
   "Please contact us for current promotions":"Please contact us for current promotions",
   "Sorry":"Sorry, You Don't Have Special Offer",
   "Any questions? Please contact your course advisor":"Any questions? Please contact your course advisor",
   "Password":"Password",
   "Verification Code":"Verification Code",
   "Phone number":"Phone number",
   "Passwordon":"Password",
   "Please enter the password":"Please enter the password",
   "Country Code":"Country Code",
   "Please select your country code":"Please select your country code",

   "Sign in/Sign up":"Sign in/Sign up",
   "Welcome to Panda Mandarin":"Welcome to Panda Mandarin",
   "loginSlogan": "Help children learn authentic Chinese with ease",
   "loginSubtitle": "Graded native-style Chinese courses for ages 3-18: listen and speak first, then read and write, with fun picture-book animation classes",
   "By continuing, you agree to our ": "By continuing, you agree to our ",
   "User Service Agreement": "Service",
   "Privacy Policy": "PrivacyPolicy",
   "and": "and",
   "Simplified Chinese": "简体中文",
   "English": "English",
   "Please tell us a little about yourself":"Please tell us a little about yourself",
   "Phone Number":"Phone Number",
   "Kid(s) Nickname":"Kid(s) Nickname",
   "Email address":"Email address",
   "Wechat ID":"Wechat ID",
   "Submit":"Submit",
   "Thank you for choosing us":"Thank you for choosing us",
   "Your Course Adviser will contact you shortly":"Your Course Adviser will contact you shortly",
   "Back":"Back",
   "searchArea":"Search Area Code",
   "Please verify and enter the text in the picture":"Please verify and enter the text in the picture",
   "The Verification Code can not be empty":"The Verification Code can not be empty",
   "Please enter the contents":"Please enter the contents",
   "Successon":"Submit",
   "Please verify":"Please verify",
   "User Does Not Exist":"User does not exists, please try again",
   "Price":"Price",
   "Processing Fee (3%)":"Processing Fee (3%)",
   "USD":"USD",
   "Wrong password":"Wrong password, please try again",
   "Enrich kids education and keep them ahead of the curve": "Enrich kids' education and keep them ahead of the curve",
   'One Pass that Meets Your Kids Learning Needs': `One Pass that Meets Your Kids' Learning Needs`,
   "Unlimited Pass": "Unlimited Pass",
   "Non-Refundable portion": "Non-Refundable portion",
   "Refundable portion, Transaction fee will be charged for refund": "Refundable portion, Transaction fee will be charged for refund",
   "Top Certified U.S. Teachers": "Top Certified U.S. Teachers",
   "100%-Live-Classes": "100% Live Classes",
   "Take classes in any subjects": "Take classes in any subjects",
   "Customized Schedule":"Customized Schedule",
   "Credits never expire": "Credits never expire",
   "Package details": "Package details",
   "PLAN DETAILS": "PLAN DETAILS",
   "Number of Students": "Number of Students",
   "Buy Now": "Buy Now",
   "Payment amount": "Payment amount",
   "I agree to the": "I agree to the",
   "Please agree to the service agreement": "Please agree to the service agreement",
   "Subscribe Now": "Subscribe Now",
   "Lesson Top-up": "Lesson Top-up",
   "Membership Subscription": "Membership",
   "Start authentic Chinese journey": "Start Your Child's Authentic Chinese Journey",
   "Recommended": "Recommended",
   "Original price": "Original",
   "As low as": "As low as",
   "Per month unit": "/mo",
   "Vip card title": "{n}-Month {title}",
   "Gift lessons": "Gift {n} lessons",
   "Total lessons": "Total {n} lessons",
   "Lessons unit": "lessons",
   "1 child": "1 child",
   "2 children": "2 children",
   "3 children": "3 children",
   "Congratulations!":"Congratulations!",
    "You have claimed a free trial lesson":"You have claimed a free trial lesson",
   "Our Course Adviser will contact you shortly":"Our Course Adviser will contact you shortly",
   "Wechatpay":"Wechatpay",
   "Transaction":"Transaction",
   "Coupon Code":"Coupon Code",
   "Panda Mandarin Project": "Panda Mandarin Project",
   "Download Center": "Download Center",
   "Student App": "Student",
   "Parent App": "Parent",
   "Download on App Store": "App Store",
   "Download on Google Play": "Google Play",
   "Xiaohongshu ID": "Xiaohongshu",
   "Contact Phone": "Contact",
   "US Headquarters": "US Headquarters",
   "Not logged in": "Sign in",
   "Student Name": "Student Name",
   "Parent Phone": "Parent Phone",
   "E-mail": "Email",
   "Interested Course": "Interested Course",
   "Submit": "Submit",
   "Submit success": "Submitted successfully",
   "Submit failed": "Submit failed, please try again",
   "Please enter student name": "Please enter student name",
   "Please enter parent phone": "Please enter parent phone",
   "Please enter email": "Please enter email",
   "Please enter interested course": "Please enter interested course",
}



// WEBPACK FOOTER //
// ./src/locales/en.js